var active_swatch = document.getElementById('active-swatch');
var classname;
if(active_swatch != null){
    if(active_swatch.classList.contains('change-background')) {
        changeProductBackground(active_swatch.dataset.background);
    }
    classname = active_swatch.dataset.swatchColour;
    updateBodyClassName('swatch-'+classname);
    updateLinkedProductUrls(classname);
}

function swatchSelected(el, changeBackground) {
    var classname = el.getAttribute('class');
    classname = classname.replace("swatch ", "");
    classname = classname.replace("edition ", "");
    if(changeBackground) {
        var background = 'var(--background-'+classname+', #000000)';
        changeProductBackground(background);
    }

    updateBodyClassName(classname);

    updateLinkedProductUrls(classname);
}

function changeProductBackground(css_var) {
    
    document.body.classList.add('swatch-styles');
    
}

function updateBodyClassName(newClassName) {
    for (let i = document.body.classList.length - 1; i >= 0; i--) {
        const className = document.body.classList[i];
        if (className.startsWith('selected-swatch')) {
            document.body.classList.remove(className);
        }
    }
    document.body.classList.add('selected-'+newClassName);
}

function updateLinkedProductUrls(classname) {
    const linked_products = document.getElementsByClassName("linked-product-option");
    let data_attribute_name = 'data-lp-variant-' + classname.toLowerCase().replace('swatch-', '');
    for (let i = 0; i < linked_products.length; i++) {
        let url = linked_products[i].getAttribute(data_attribute_name);
        if(url) {
            linked_products[i].href = url;
        } 
    }
}